import styles from './FJSubtitleSetting.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJSwitchButton from '../../../common/components/FJSwitchButton/FJSwitchButton';
import FJSubtitleStyleItem from './FJSubtitleStyleItem/FJSubtitleStyleItem';
import FJSwipe from '../../../common/components/FJSwipe/FJSwipe';
import { SUBTITLE_STYLE_LIST } from '../../../config/dataConfig/FJTextToVideoDataConfig';
const FJSubtitleSetting = props => {
    const { subtitleSettingActive, onSubtitleSettingActiveChange, subtitleStyle, subtitleStyleChange } = props;
    const _getComp = () => {
        // if (!subtitleSettingActive) return null;
        return (
            <FJSwipe itemWidth={134} space={10} className={styles.style_container} needUpdate={true}>
                {SUBTITLE_STYLE_LIST.map(item => {
                    let showText = item.text;
                    if (item.text === 'shadow') {
                        showText = '3D-shadow';
                    }
                    return (
                        <FJSubtitleStyleItem
                            key={item.id}
                            url={item.imgUrl}
                            videoUrl={item.videoUrl}
                            onItemClick={() => {
                                subtitleStyleChange(item);
                            }}
                            isSelect={item.id === subtitleStyle.id}
                            text={showText}
                            style={{ width: '134px' }}
                        />
                    );
                })}
            </FJSwipe>
        );
    };
    return (
        <div className={classNames(styles.container, subtitleSettingActive && styles.active)}>
            <div className={styles.header}>
                <div className={classNames(styles.header_title)}>{FJLocalStore._('subtitle-settings')}</div>
                <FJSwitchButton
                    active={subtitleSettingActive}
                    onChange={onSubtitleSettingActiveChange}
                    type='gradient'
                />
            </div>
            {_getComp()}
        </div>
    );
};

FJSubtitleSetting.propTypes = {
    subtitleSettingActive: PropTypes.bool,
    onSubtitleSettingActiveChange: PropTypes.func,
    subtitleStyle: PropTypes.object,
    subtitleStyleChange: PropTypes.func,
};

export default FJSubtitleSetting;
